import {
  GET_SITE,
  GET_SITE_PAGENATION,
  IMPORT_CSV,
  GET_SITE_DETAIL,
  SAVE_SITE,
  UPDATE_CONST_DONE,
  DELETE_SITE
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_SITE]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/sites",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_SITE_PAGENATION]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/sites/pagenation",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_SITE_DETAIL]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/sites/get_site_detail",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SAVE_SITE]({ dispatch }, params) {
      let url = "/kanri/sites/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [UPDATE_CONST_DONE]({ dispatch }, params) {
      let url = "/kanri/sites/update_const_done";
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_SITE]({ dispatch }, params) {
      let url = "/kanri/sites/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [IMPORT_CSV]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/sites/import_csv",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
